
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Ogólne',
	'widgetId': 'Identyfikator widgetu',
	'widgetType': 'Typ widgetu',
	'serviceability': 'Łatwość serwisowania',
	'copyButton': 'Kopiuj',
	'closeButton': 'Zamknij',
	'specification': 'Specyfikacja',
	'viewSpecification': 'Specyfikacja widoku'
});
